import { createRouter } from '@tanstack/react-router';
import { rotaRaiz } from './rotas/raiz';
import { rotaPainel } from './rotas/painel';
import { rotaEntrar } from './rotas/entrar';
import { rotaRedefinirSenha } from './rotas/redefinir-senha';
import { rotaAtividade } from './rotas/atividade';
import { rotaInicio } from './rotas/index';
import { rotaMaquinas } from './rotas/maquinas';
import { rotaUsuarios } from './rotas/usuarios';
import { rotaAudio } from './rotas/audio';
import { rotaAudioDetalhe } from './rotas/audio.detalhe';
import { rotaSessoes } from './rotas/sessoes';
import { rotaSessao } from './rotas/sessao';
import { rotaGravar } from './rotas/audio.gravar';
import { rotaNovaSessao } from './rotas/sessao.nova';
import { rotaArquivos } from './rotas/arquivos';
import { rotaSaude } from './rotas/saude';
import { rotaNotificacoes } from './rotas/notificacoes';
import { rotaUso } from './rotas/uso';
import { rotaConfiguracoes } from './rotas/configuracoes';
import { rotaToolkit } from './rotas/toolkit';
import { rotaNovaRotina, rotaNovaVersaoDaRotina, rotaRotinaDoToolkit } from './rotas/toolkit.rotina';

/**
 * Tudo que exige sessão pendura na moldura (`rotaPainel`), que monta uma vez e
 * sobrevive à navegação. Fora dela ficam só duas famílias: a tela de entrar,
 * que existe sem sessão, e os três endereços antigos, que apenas redirecionam
 * — montar a moldura para descartá-la no mesmo instante seria desperdício.
 */
const arvore = rotaRaiz.addChildren([
  rotaPainel.addChildren([
    rotaInicio,
    rotaMaquinas,
    rotaUsuarios,
    rotaAtividade,
    rotaAudio,
    rotaAudioDetalhe,
    rotaNovaSessao,
    rotaGravar,
    rotaSaude,
    rotaNotificacoes,
    rotaUso,
    rotaConfiguracoes,
    rotaToolkit,
    rotaNovaRotina,
    rotaRotinaDoToolkit,
    rotaNovaVersaoDaRotina,
  ]),
  rotaEntrar,
  // Fora da moldura, como a tela de entrar: quem chega aqui não tem sessão.
  rotaRedefinirSenha,
  rotaSessoes,
  rotaSessao,
  rotaArquivos,
]);

export const roteador = createRouter({ routeTree: arvore, defaultPreload: 'intent' });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof roteador;
  }
}
